import { Booking } from 'src/app/models/member';
import { MembershipAction } from 'src/app/models/enums';

/**
 * DFS-1821 / DFS-1817: matching MenuPackId and Action !== Canceled.
 * Used by Pricing Active badge and the shared checkout gate.
 */
export function isSubscriptionMenuPackActive(
  menuPackId: number,
  subscriptions: Booking[] | null | undefined,
): boolean {
  if (!menuPackId || !subscriptions?.length) {
    return false;
  }

  return subscriptions.some(
    (sub) =>
      sub?.MenuPackId === menuPackId &&
      sub.Action !== MembershipAction.Canceled,
  );
}

/**
 * Shared gate for openCheckoutPopup — covers Pricing Select, selectedItemId,
 * short_code, and PaymentLink invite_code. Payment links intentionally follow
 * the same owned-pack rule (no override).
 */
export function shouldOpenCheckoutForMenuPack(
  menuPackId: number,
  subscriptions: Booking[] | null | undefined,
): boolean {
  return (
    menuPackId > 0 &&
    !isSubscriptionMenuPackActive(menuPackId, subscriptions)
  );
}
